import React from 'react';
import PropTypes from 'prop-types';
import { createCallList } from 'components/call_lists/api';
import { Form } from 'react-bootstrap-5';
import Button from 'shared/button';

export default class CallListForm extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  state = { newCallListName: null };

  createNewCallList = () => {
    const { onClose } = this.props;
    const { newCallListName } = this.state;

    const payload = { name: newCallListName };
    createCallList(payload, onClose);
  }

  setNewCallListName = (event) => {
    this.setState({ newCallListName: event.target.value });
  }

  render() {
    const { onClose } = this.props;
    return (
      <Form.Group className="form-group">
        <Form.Label className="w-100">
          Name: <br />
        </Form.Label>
        <Form.Control
          className="form-control"
          name="name"
          placeholder={"Enter a new name"}
          type="text"
          onChange={this.setNewCallListName}
        />
        <div className="mt-4">
          <Button.Cancel
            name="cancel-button"
            onClick={() => onClose()}
          >
            Cancel
          </Button.Cancel>
          <Button.Primary
            className="ms-3"
            name="create-queue-button"
            onClick={this.createNewCallList}
          >
            Create Call List
          </Button.Primary>
        </div>
      </Form.Group>
    );
  }
}
